module.exports = __webpack_public_path__ + "img/edit-pencil.e1d7825f.svg";